// extracted by mini-css-extract-plugin
export default {"contenedorCuadros":"HomeTorneosInt_contenedorCuadros__uTUUi"};